import { ListItem, List } from '@material-ui/core';

import styled from 'styled-components';

export const ListItemCard = styled(ListItem)`
  padding: 3px !important;
`;

export const SvgList = styled(List)`
  display: flex !important;
  flex-wrap: wrap !important;
  padding: 0 !important;
  justify-content: space-around !important;

  li {
    width: fit-content;
  }
`;

export const Svg = styled.svg`
  width: 35px;
  height: 25px;
`;
